import cardIcon from "../assets/images/card-icon.png";

export const Setting = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none">
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <g clipPath="url(#clip0_3800_3759)">
        <path
          d="M15.5 8C15.5 7.24659 14.8898 6.63636 14.1364 6.63636H13.2759C13.147 6.13727 12.9507 5.66682 12.695 5.23318L13.3032 4.625C13.8357 4.0925 13.8357 3.22932 13.3032 2.69682C12.7707 2.16432 11.9075 2.16432 11.375 2.69682L10.7668 3.305C10.3332 3.04932 9.86273 2.85295 9.36364 2.72409V1.86364C9.36364 1.11091 8.75341 0.5 8 0.5C7.24659 0.5 6.63636 1.11023 6.63636 1.86364V2.72409C6.13727 2.85295 5.66682 3.04932 5.23318 3.305L4.625 2.69682C4.0925 2.16432 3.22932 2.16432 2.69682 2.69682C2.16432 3.22932 2.16432 4.0925 2.69682 4.625L3.305 5.23318C3.04932 5.66682 2.85295 6.13727 2.72409 6.63636H1.86364C1.11091 6.63636 0.5 7.24659 0.5 8C0.5 8.75341 1.11023 9.36364 1.86364 9.36364H2.72409C2.85295 9.86273 3.04932 10.3332 3.305 10.7668L2.69682 11.375C2.16432 11.9075 2.16432 12.7707 2.69682 13.3032C3.22932 13.8357 4.0925 13.8357 4.625 13.3032L5.23318 12.695C5.66614 12.9507 6.13727 13.147 6.63636 13.2759V14.1364C6.63636 14.8891 7.24659 15.5 8 15.5C8.75341 15.5 9.36364 14.8898 9.36364 14.1364V13.2759C9.86273 13.147 10.3332 12.9507 10.7668 12.695L11.375 13.3032C11.9075 13.8357 12.7707 13.8357 13.3032 13.3032C13.8357 12.7707 13.8357 11.9075 13.3032 11.375L12.695 10.7668C12.9507 10.3339 13.147 9.86273 13.2759 9.36364H14.1364C14.8891 9.36364 15.5 8.75341 15.5 8Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00004 10.0455C9.12972 10.0455 10.0455 9.12972 10.0455 8.00004C10.0455 6.87037 9.12972 5.95459 8.00004 5.95459C6.87037 5.95459 5.95459 6.87037 5.95459 8.00004C5.95459 9.12972 6.87037 10.0455 8.00004 10.0455Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3800_3759">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HandIndicator = () => {
  return (
    <svg
      width="800px"
      height="800px"
      className="hand-indicator"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <path fill="#0089FF" d="M8 13.1l-8-8 2.1-2.2 5.9 5.9 5.9-5.9 2.1 2.2z" />
    </svg>
  );
};

export const SpeakerOff = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        cursor: "inherit",
      }}>
      <g clipPath="url(#clip0_3604_121041)">
        <path
          d="M14.7917 8.95831V18.125L9.63583 14.2583"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.45833 13.125H1.45833V6.45831H8.125L14.7917 1.45831V4.79165"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.9583 0.625L0.625 18.9583"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3604_121041">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GameInfo = () => {
  return (
    <svg
      fill="#a0a0a0"
      viewBox="0 0 64 64"
      className="svg-icon "
      width={18}
      height={18}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8 8.547h36.774c0 .028.026.054.026.054h-.016a6.75 6.75 0 0 0-6.384 6.586v33.04l-.002-.02a6.8 6.8 0 0 1-6.786 7.246 6.8 6.8 0 0 1-6.786-7.226v-3.094H16V15.347a6.8 6.8 0 0 1 6.8-6.8Zm-.828 27.894h15.494V31.8H21.972v4.64Zm.002-12.4h24.8V19.4h-24.8v4.64Zm38.052-13.574h-.052A3.974 3.974 0 0 0 56 14.44v6.426h8V14.44a3.974 3.974 0 0 0-3.974-3.974ZM36.8 48.256H0a6.8 6.8 0 0 0 6.8 6.8h34.026c-2.694 0-4.026-3.04-4.026-6.8Z"
      />
    </svg>
  );
};

export const SpeakerOn = () => {
  return (
    <svg
      id="Capa_1"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={18}
      height={18}
      viewBox="0 0 489.051 489.051"
      enableBackground="new 0 0 489.051 489.051"
      >
      <g>
        <g>
          <g>
            <g>
              <path d="M306.065,484.56l-163.3-117.6h-95.8c-26,0-46.8-21.8-46.8-48.9v-148.7c0-27,20.8-48.9,46.8-48.9h95.7l163.4-116.6          c21.7-11.9,33,6.7,32.3,15.6v448.4C339.865,477.76,323.365,498.06,306.065,484.56z M46.965,162.06c-3.1,0-5.2,3.1-5.2,8.3v148.8          c0,4.2,3.1,8.3,5.2,8.3h102c4.2,0,8.3,1,11.4,4.2l136.3,97.7V60.06l-136.3,97.8c-3.1,2.1-7.3,4.2-11.4,4.2H46.965z" />
            </g>
            <g>
              <path d="M446.465,401.36c-10.4-3.1-17.7-13.5-14.6-25c37.5-149.8,1-263.2,0-264.2c-3.1-10.4,2.1-21.8,12.5-26          c10.4-3.1,21.8,2.1,26,12.5c2.1,5.2,40.6,125.9,0,287.1C468.365,396.16,458.165,405.46,446.465,401.36z" />
            </g>
            <g>
              <path d="M385.165,322.26c-10.4-3.1-17.7-13.5-14.6-25c14.6-59.3,1-105.1,0-106.1c-3.1-10.4,2.1-21.8,13.5-26          c10.4-3.1,21.8,2.1,26,12.5c1,2.1,18.7,57.2,0,129C407.965,317.06,398.365,325.86,385.165,322.26z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Redirect = () => {
  return (
    <svg fill="currentColor" viewBox="0 0 64 64" className="svg-icon redirect">
      {" "}
      <title></title>{" "}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.823 53.176h42.353V39.941h7.059v20.294H3.765V3.765h20.293v7.058H10.823v42.353Zm28.236-42.353V3.765h21.176V24.94h-7.059v-9.123L27.88 41.115l-4.994-4.995 25.297-25.296H39.06Z"></path>
    </svg>
  );
};

export const Copy = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none">
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <path
        d="M12.719 4H5.78A1.78 1.78 0 0 0 4 5.781v6.938A1.78 1.78 0 0 0 5.781 14.5h6.938a1.78 1.78 0 0 0 1.781-1.781V5.78A1.78 1.78 0 0 0 12.719 4Z"
        stroke="#9BA5B4"
        strokeLinejoin="round"
      />
      <path
        d="M11.984 4 12 3.25a1.755 1.755 0 0 0-1.75-1.75H3.5a2.006 2.006 0 0 0-2 2v6.75A1.755 1.755 0 0 0 3.25 12H4"
        stroke="#9BA5B4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Active = () => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    //   style={{
    //     enableBackground: "new 0 0 512 512",
    //   }}
      fill="#08b9af"
      xmlSpace="preserve">
      <path
        style={{
          fill: "#0089FF",
        }}
        d="M505.183,123.179c-9.087-9.087-23.824-9.089-32.912,0.002l-216.266,216.27L39.729,123.179 c-9.087-9.087-23.824-9.089-32.912,0.002c-9.089,9.089-9.089,23.824,0,32.912L239.55,388.82c4.364,4.364,10.283,6.816,16.455,6.816 c6.172,0,12.092-2.453,16.455-6.817l232.721-232.727C514.272,147.004,514.272,132.268,505.183,123.179z"
      />
    </svg>
  );
};

export const Cross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      fill="#fff"
      height="24"
      viewBox="0 0 24 24">
      <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
    </svg>
  );
};

 
// export const Star = ({ toggleFavourite }) => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width={16}
//       height={16}
//       viewBox="0 0 16 16"
//       fill="none">
//       <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
//       <script />
//       <script />
//       <g clipPath="url(#clip0_8517_139575)">
//         {toggleFavourite ? (
//           <path
//             d="M8.48587 0.800092L10.7165 5.21943L15.0099 5.64476C15.1121 5.65325 15.2097 5.69085 15.2912 5.75311C15.3727 5.81537 15.4347 5.89968 15.4697 5.99606C15.5048 6.09244 15.5115 6.19685 15.4891 6.29693C15.4667 6.39701 15.416 6.48856 15.3432 6.56076L11.8099 10.0628L13.1199 14.8214C13.1467 14.9224 13.1437 15.0289 13.1114 15.1282C13.0791 15.2275 13.0188 15.3154 12.9378 15.3812C12.8567 15.4471 12.7583 15.4881 12.6545 15.4994C12.5507 15.5106 12.4458 15.4917 12.3525 15.4448L7.99987 13.2894L3.6532 15.4421C3.5599 15.489 3.45503 15.508 3.35121 15.4967C3.24739 15.4854 3.14903 15.4444 3.06797 15.3786C2.98691 15.3127 2.9266 15.2248 2.8943 15.1255C2.86199 15.0262 2.85906 14.9197 2.88587 14.8188L4.19587 10.0601L0.659866 6.55809C0.587021 6.4859 0.536388 6.39434 0.513963 6.29426C0.491537 6.19418 0.498259 6.08977 0.53333 5.9934C0.568402 5.89702 0.630356 5.81271 0.711857 5.75045C0.793357 5.68819 0.890992 5.65059 0.9932 5.64209L5.28653 5.21676L7.51387 0.800092C7.55967 0.710626 7.62929 0.63554 7.71504 0.583107C7.80079 0.530674 7.89935 0.50293 7.99987 0.50293C8.10038 0.50293 8.19894 0.530674 8.28469 0.583107C8.37044 0.63554 8.44006 0.710626 8.48587 0.800092V0.800092Z"
//             fill="#c9335c"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         ) : (
//           <path
//             d="M8.48587 0.800092L10.7165 5.21943L15.0099 5.64476C15.1121 5.65325 15.2097 5.69085 15.2912 5.75311C15.3727 5.81537 15.4347 5.89968 15.4697 5.99606C15.5048 6.09244 15.5115 6.19685 15.4891 6.29693C15.4667 6.39701 15.416 6.48856 15.3432 6.56076L11.8099 10.0628L13.1199 14.8214C13.1467 14.9224 13.1437 15.0289 13.1114 15.1282C13.0791 15.2275 13.0188 15.3154 12.9378 15.3812C12.8567 15.4471 12.7583 15.4881 12.6545 15.4994C12.5507 15.5106 12.4458 15.4917 12.3525 15.4448L7.99987 13.2894L3.6532 15.4421C3.5599 15.489 3.45503 15.508 3.35121 15.4967C3.24739 15.4854 3.14903 15.4444 3.06797 15.3786C2.98691 15.3127 2.9266 15.2248 2.8943 15.1255C2.86199 15.0262 2.85906 14.9197 2.88587 14.8188L4.19587 10.0601L0.659866 6.55809C0.587021 6.4859 0.536388 6.39434 0.513963 6.29426C0.491537 6.19418 0.498259 6.08977 0.53333 5.9934C0.568402 5.89702 0.630356 5.81271 0.711857 5.75045C0.793357 5.68819 0.890992 5.65059 0.9932 5.64209L5.28653 5.21676L7.51387 0.800092C7.55967 0.710626 7.62929 0.63554 7.71504 0.583107C7.80079 0.530674 7.89935 0.50293 7.99987 0.50293C8.10038 0.50293 8.19894 0.530674 8.28469 0.583107C8.37044 0.63554 8.44006 0.710626 8.48587 0.800092V0.800092Z"
//             stroke="white"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         )}
//       </g>
//       <defs>
//         <clipPath id="clip0_8517_139575">
//           <rect width={16} height={16} fill="white" />
//         </clipPath>
//       </defs>
//     </svg>
//   );
// };

export const Keyboard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      style={{
        cursor: "inherit",
      }}>
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <g stroke="white" clipPath="url(#clip0_6673_527530)">
        <path
          d="M15.5 6.5H0.5V15.5H15.5V6.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 12.5H2.5H3.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 12.5H5.5H9.5H10.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 12.5H12.5H13.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 9.5H2.5H3.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 9.5H9.5H10.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 9.5H12.5H13.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5.5 9.5H6.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M11.5 3.5L8 0.5L4.5 3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6673_527530">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Tick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      style={{
        cursor: "inherit",
      }}>
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <path
        d="M1.33594 7.99984L4.83594 11.3332L6.58594 9.33317M5.33594 7.99984L8.83594 11.3332L14.6693 4.6665M10.6693 4.6665L8.33594 7.33317"
        stroke="#9BA5B4"
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Heart = () => {
  return (
    <svg
      width={44}
      height={41}
      viewBox="0 0 44 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <title>{"HEARTS"}</title>
      <path
        d="M4.02689 22.5732C1.58982 20.1518 0.252441 16.9345 0.252441 13.5147C0.252441 10.095 1.59661 6.87089 4.02689 4.45618C6.46397 2.03473 9.70204 0.706009 13.1438 0.706009C16.5856 0.706009 19.6268 1.96057 22.0367 4.24038C24.4467 1.96057 27.5898 0.706009 30.9298 0.706009C34.2697 0.706009 37.6096 2.04148 40.0467 4.45618C42.4838 6.87089 43.8211 10.095 43.8211 13.5147C43.8211 16.9345 42.477 20.1518 40.0467 22.5732L22.0367 40.4677L4.02689 22.5732Z"
        fill="#B4171E"
      />
    </svg>
  );
};

export const Club = () => {
  return (
    <svg
      width={42}
      height={42}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <title>{"CLUBS"}</title>
      <path
        d="M0.785645 25.2221C0.785645 30.5782 5.13032 34.9229 10.4865 34.9229C13.7992 34.9229 16.7115 33.2597 18.4629 30.7276C19.0671 30.1981 19.8342 29.8858 20.6692 29.7772V32.4179C20.6692 36.9391 17.0035 40.6049 12.4824 40.6049V41.5552H29.7863V40.6049C25.2652 40.6049 21.5993 36.9391 21.5993 32.4179V29.7772C22.4343 29.8858 23.2014 30.1981 23.8056 30.7276C25.557 33.2597 28.4761 34.9229 31.7821 34.9229C37.1382 34.9229 41.4829 30.5782 41.4829 25.2221C41.4829 19.866 37.1382 15.5213 31.7821 15.5213C30.5873 15.5213 29.4604 15.7657 28.4082 16.1594C29.9017 14.4555 30.8384 12.2425 30.8384 9.79859C30.8384 4.44246 26.4939 0.0978088 21.1377 0.0978088C15.7816 0.0978088 11.4369 4.44246 11.4369 9.79859C11.4369 12.2425 12.3736 14.4487 13.8671 16.1594C12.8149 15.7657 11.6812 15.5213 10.4932 15.5213C5.13711 15.5213 0.79244 19.866 0.79244 25.2221H0.785645Z"
        fill="black"
      />
    </svg>
  );
};

export const Diamond = () => {
  return (
    <svg
      width={42}
      height={43}
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <title>{"DIAMONDS"}</title>
      <path
        d="M31.1438 13.4267C26.4533 8.8794 23.3377 4.42757 21.2924 0.909729C19.2472 4.42757 16.1384 8.8794 11.4411 13.4267C7.746 17.0059 4.02365 19.7192 0.84668 21.7304C4.02365 23.7416 7.746 26.455 11.4411 30.0342C16.1316 34.5815 19.2472 39.0333 21.2924 42.5511C23.3377 39.0333 26.4465 34.5815 31.1438 30.0342C34.8389 26.455 38.5544 23.7416 41.7382 21.7304C38.5612 19.7192 34.8389 17.0059 31.1438 13.4267Z"
        fill="#B4171E"
      />
    </svg>
  );
};

export const Spade = () => {
  return (
    <svg
      width={59}
      height={62}
      viewBox="0 0 59 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <title>{"SPADES"}</title>
      <path
        d="M29.5 0.820068L5.28005 25.04C-0.859951 31.18 -0.859951 41.1401 5.28005 47.2801C11.42 53.4201 21.38 53.4201 27.52 47.2801L28.82 45.98V48.5001C28.82 55.1301 23.45 60.5001 16.82 60.5001V61.8901H42.19V60.5001C35.56 60.5001 30.19 55.1301 30.19 48.5001V45.97L31.49 47.2701C37.63 53.4101 47.59 53.4101 53.73 47.2701C59.87 41.1301 59.87 31.1701 53.73 25.0301L29.51 0.810059L29.5 0.820068Z"
        fill="black"
      />
    </svg>
  );
};

export const CardIcon = () => {
  return <img src={cardIcon} alt="" />;
};

export const Shuffle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={56}
      height={65}
      viewBox="0 0 56 65"
      fill="none">
      <title>{"Card Icon"}</title>
      <g filter="url(#a)">
        <path
          fill="#250059"
          d="M41.747.27h-27.81c-3.559 0-6.91 1.415-9.425 3.97a13.577 13.577 0 0 0-3.903 9.576v4.15c0 5.525 3.42 10.367 9.152 12.956l2.288.952V18.168a1.554 1.554 0 0 1-.014-.207v-4.15c0-.702.353-1.16.561-1.371a1.88 1.88 0 0 1 1.346-.57h27.81c.691 0 1.141.353 1.35.57.21.212.557.67.557 1.367v9.104h11.422v-9.1c0-3.616-1.388-7.02-3.903-9.575C48.653 1.68 45.307.27 41.747.27Z"
        />
      </g>
      <g filter="url(#b)">
        <path
          fill="#250059"
          d="m45.882 33.426-2.241-.934v13.8c.009.034.009.071.009.104v4.15c0 .702-.348 1.164-.562 1.376-.209.212-.659.57-1.346.57H13.938c-1.05 0-1.903-.871-1.903-1.932v-9.105H.609v9.105c0 7.468 5.977 13.54 13.329 13.54h27.809c3.56-.004 6.91-1.414 9.426-3.97 2.515-2.56 3.903-5.964 3.903-9.58v-4.149c0-5.578-3.434-10.43-9.194-12.97v-.005Z"
        />
      </g>
      <g filter="url(#c)">
        <path
          fill="#250059"
          d="M22.932 37.173c3.991 4.055 4.91 9.19 4.91 9.19s.599-3.305 2.896-6.705c.566-.839 1.23-1.683 2.019-2.485 3.991-4.054 9.046-4.993 9.046-4.993s-3.816-.707-7.44-3.555c-.543-.429-1.086-.9-1.61-1.433-3.992-4.055-4.916-9.194-4.916-9.194s-.589 3.305-2.886 6.714a17.433 17.433 0 0 1-2.024 2.485c-3.996 4.055-9.05 4.988-9.05 4.988s3.82.707 7.444 3.555c.543.434 1.086.905 1.61 1.438v-.005Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width={54.472}
          height={32.604}
          x={0.609}
          y={0.271}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0" />
          <feBlend in2="shape" result="effect1_innerShadow_7466_393493" />
        </filter>
        <filter
          id="b"
          width={54.468}
          height={32.608}
          x={0.609}
          y={32.492}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0" />
          <feBlend in2="shape" result="effect1_innerShadow_7466_393493" />
        </filter>
        <filter
          id="c"
          width={27.925}
          height={29.365}
          x={13.877}
          y={17.998}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0" />
          <feBlend in2="shape" result="effect1_innerShadow_7466_393493" />
        </filter>
      </defs>
    </svg>
  );
};

export const Hit = () => {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#hit_svg__a)" fill="#3DD179">
        <path d="M4.538 9.309a.5.5 0 0 0 .108.545l3 3a.5.5 0 0 0 .707 0l3-3A.5.5 0 0 0 11 9H9V1a1 1 0 1 0-2 0v8H5a.5.5 0 0 0-.462.309Z" />
        <path d="m15.994 14.89-1-9A1 1 0 0 0 14 5h-3v2h2.1l.78 7H2.116L2.9 7H5V5H2a1 1 0 0 0-.994.89l-1 9A1 1 0 0 0 1 16h14a1 1 0 0 0 .994-1.11Z" />
      </g>
      <defs>
        <clipPath id="hit_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Stand = () => {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#stand_svg__a)">
        <path
          d="M15 2a1 1 0 0 0-1 1v4a.5.5 0 0 1-1 0V1.553a1.037 1.037 0 0 0-.832-1.04A1 1 0 0 0 11 1.5V7a.5.5 0 0 1-1 0V1.053A1.037 1.037 0 0 0 9.168.014 1 1 0 0 0 8 1v6a.5.5 0 0 1-1 0V1.553A1.037 1.037 0 0 0 6.168.514 1 1 0 0 0 5 1.5v7.793a.5.5 0 0 1-.854.354l-2-2A1.08 1.08 0 0 0 .91 7.4a1.032 1.032 0 0 0-.442 1.434l2.31 4.108A6 6 0 0 0 8.01 16h1.99a6 6 0 0 0 6-6V3a1 1 0 0 0-1-1Z"
          fill="#F1323E"
        />
      </g>
      <defs>
        <clipPath id="stand_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Split = () => {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#split_svg__a)" fill="#4185F0">
        <path d="M15.5 0h-5a.5.5 0 0 0-.354.854l1.793 1.792-1.646 1.647a1 1 0 1 0 1.414 1.414l1.647-1.646 1.792 1.793A.5.5 0 0 0 16 5.5v-5a.5.5 0 0 0-.5-.5ZM4.061 2.646 5.854.854A.5.5 0 0 0 5.5 0h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .854.354l1.792-1.793L7 8.414V15a1 1 0 1 0 2 0V8a1 1 0 0 0-.293-.707L4.061 2.646Z" />
      </g>
      <defs>
        <clipPath id="split_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Double = () => {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#double_svg__a)" fill="#FFC634">
        <path d="M9 0H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z" />
        <path d="m15.124 4.085-3-.375-.248 1.984 2.007.251-.995 7.938-6.946-.871L5.694 15l7.938 1a1 1 0 0 0 1.117-.868L15.992 5.2a1 1 0 0 0-.868-1.115Z" />
      </g>
      <defs>
        <clipPath id="double_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 398.72 398.72">
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <defs>
        <style>
          {
            "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        opacity: .88;\n      }\n\n      .cls-4 {\n        fill: #c46b00;\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        fill-rule: evenodd;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-5);\n      }\n    "
          }
        </style>
        <linearGradient
          id="linear-gradient"
          x1={58.39}
          y1={-118.73}
          x2={340.33}
          y2={-400.67}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#ffffcd" />
          <stop offset={0.05} stopColor="#fffdbc" />
          <stop offset={0.14} stopColor="#fff891" />
          <stop offset={0.26} stopColor="#fff04c" />
          <stop offset={0.33} stopColor="#ffec23" />
          <stop offset={0.39} stopColor="#ffdd1b" />
          <stop offset={0.53} stopColor="#ffc40f" />
          <stop offset={0.67} stopColor="#ffb306" />
          <stop offset={0.83} stopColor="#ffa801" />
          <stop offset={1} stopColor="orange" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1={197.43}
          y1={-266.7}
          x2={197.92}
          y2={-265.65}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#5fa100" />
          <stop offset={1} stopColor="#7ba100" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1={114.05}
          y1={-181.27}
          x2={277.79}
          y2={-345.01}
          gradientTransform="translate(243.45 -121.8) rotate(45) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#ffdc0a" />
          <stop offset={0.08} stopColor="#fdd509" />
          <stop offset={0.67} stopColor="#f6a502" />
          <stop offset={0.96} stopColor="#f39300" />
          <stop offset={0.97} stopColor="#f49500" />
          <stop offset={1} stopColor="orange" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1={57.4}
          y1={-259.7}
          x2={341.4}
          y2={-259.7}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0.33} stopColor="#ffe763" />
          <stop offset={0.36} stopColor="#ffde58" />
          <stop offset={0.48} stopColor="#ffc438" />
          <stop offset={0.59} stopColor="#ffb01f" />
          <stop offset={0.72} stopColor="#ffa20e" />
          <stop offset={0.85} stopColor="#ff9903" />
          <stop offset={1} stopColor="#ff9700" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-5"
          x1={197.68}
          y1={-266.48}
          x2={197.68}
          y2={-265.54}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1={197.68}
          y1={-266.48}
          x2={197.68}
          y2={-265.54}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1={197.68}
          y1={-266.48}
          x2={197.68}
          y2={-265.54}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-8"
          x1={197.68}
          y1={-266.48}
          x2={197.68}
          y2={-265.54}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-9"
          x1={3.86}
          y1={-196.57}
          x2={356.14}
          y2={-196.57}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" stopOpacity={0} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.06} />
          <stop offset={0.03} stopColor="#fff" stopOpacity={0.26} />
          <stop offset={0.05} stopColor="#fff" stopOpacity={0.44} />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.59} />
          <stop offset={0.1} stopColor="#fff" stopOpacity={0.72} />
          <stop offset={0.13} stopColor="#fff" stopOpacity={0.82} />
          <stop offset={0.16} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.96} />
          <stop offset={0.24} stopColor="#fff" stopOpacity={0.99} />
          <stop offset={0.31} stopColor="#fff" />
          <stop offset={0.38} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.61} stopColor="#fff" stopOpacity={0.56} />
          <stop offset={0.79} stopColor="#fff" stopOpacity={0.31} />
          <stop offset={0.93} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="linear-gradient-10"
          x1={57.45}
          y1={-259.61}
          x2={341.44}
          y2={-259.61}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="orange" />
          <stop offset={1} stopColor="#c46b00" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-11"
          x1={98.87}
          y1={-260.15}
          x2={191.91}
          y2={-260.15}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.99} stopColor="#a21645" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-12"
          x1={196.8}
          y1={-260.2}
          x2={272.45}
          y2={-260.2}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.99} stopColor="#a21645" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-13"
          x1={116.05}
          y1={-224.65}
          x2={190.43}
          y2={-299.04}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.16} stopColor="#fff5bd" />
          <stop offset={0.54} stopColor="#ffde19" />
          <stop offset={0.58} stopColor="#ffdc0a" />
          <stop offset={1} stopColor="#ffdc0a" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-14"
          x1={214.17}
          y1={-224.39}
          x2={284.33}
          y2={-294.55}
          gradientTransform="translate(0 -60.34) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.16} stopColor="#fff5bd" />
          <stop offset={0.54} stopColor="#ffde19" />
          <stop offset={0.58} stopColor="#ffdc0a" />
          <stop offset={1} stopColor="#ffdc0a" />
        </linearGradient>
      </defs>
      <g id="_\u0428\u0430\u0440_1" data-name=" \u0428\u0430\u0440 1">
        <g>
          <g>
            <circle className="cls-1" cx={199.36} cy={199.36} r={199.36} />
            <polygon
              className="cls-7"
              points="198.23 206.15 197.9 206.04 197.97 206.3 197.75 206.12 197.68 206.44 197.61 206.15 197.39 206.34 197.46 206.08 197.17 206.15 197.39 205.9 197.13 205.82 197.39 205.75 197.13 205.5 197.46 205.6 197.39 205.35 197.61 205.53 197.68 205.2 197.75 205.53 197.97 205.35 197.9 205.6 198.23 205.5 197.97 205.75 198.26 205.82 197.97 205.9 198.23 206.15"
            />
            <circle
              className="cls-2"
              cx={195.92}
              cy={202.8}
              r={115.78}
              transform="translate(-86.02 197.93) rotate(-45)"
            />
            <path
              className="cls-4"
              d="M199.89,85.43c-27.41,0-52.57,9.54-72.4,25.46,18.44-12.41,40.65-19.66,64.56-19.66,63.94,0,115.78,51.83,115.78,115.78,0,36.53-16.94,69.09-43.37,90.31,30.89-20.79,51.22-56.08,51.22-96.12,0-63.94-51.83-115.78-115.78-115.78h0Z"
            />
            <path
              className="cls-8"
              d="M199.4,57.36c-78.42,0-142,63.58-142,142s63.58,142,142,142,142-63.58,142-142S277.82,57.36,199.4,57.36Zm0,271.16c-71.33,0-129.16-57.82-129.16-129.15S128.06,70.21,199.4,70.21s129.15,57.82,129.15,129.16-57.82,129.15-129.15,129.15h0Z"
            />
            <polygon
              className="cls-11"
              points="197.96 205.91 198.22 206.14 197.89 206.04 197.8 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.38 205.91 197.12 205.82 197.38 205.75 197.12 205.49 197.47 205.59 197.38 205.36 197.6 205.52 197.67 205.2 197.76 205.52 197.96 205.36 197.89 205.59 198.22 205.49 197.96 205.75 198.25 205.82 197.96 205.91"
            />
            <polygon
              className="cls-9"
              points="197.96 205.91 198.22 206.14 197.89 206.04 197.8 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.38 205.91 197.12 205.82 197.38 205.75 197.12 205.49 197.47 205.59 197.38 205.36 197.6 205.52 197.67 205.2 197.76 205.52 197.96 205.36 197.89 205.59 198.22 205.49 197.96 205.75 198.25 205.82 197.96 205.91"
            />
            <polygon
              className="cls-10"
              points="197.96 205.91 198.22 206.14 197.89 206.04 197.8 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.38 205.91 197.12 205.82 197.38 205.75 197.12 205.49 197.47 205.59 197.38 205.36 197.6 205.52 197.67 205.2 197.76 205.52 197.96 205.36 197.89 205.59 198.22 205.49 197.96 205.75 198.25 205.82 197.96 205.91"
            />
            <polygon
              className="cls-5"
              points="197.96 205.91 198.22 206.14 197.89 206.04 197.8 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.38 205.91 197.12 205.82 197.38 205.75 197.12 205.49 197.47 205.59 197.38 205.36 197.6 205.52 197.67 205.2 197.76 205.52 197.96 205.36 197.89 205.59 198.22 205.49 197.96 205.75 198.25 205.82 197.96 205.91"
            />
            <path
              className="cls-6"
              d="M8.94,219.42C8.94,109.18,98.31,19.81,208.55,19.81c58.48,0,111.08,25.15,147.59,65.22C320.44,37.46,263.59,6.69,199.54,6.69,91.47,6.69,3.86,94.3,3.86,202.37c0,22.19,3.75,43.5,10.56,63.39-3.54-14.88-5.47-30.38-5.47-46.34h-.01Z"
            />
            <path
              className="cls-15"
              d="M188.32,341.08c-6.67-.52-13.34-1.51-19.84-2.95l1.46-6.56c6.19,1.38,12.55,2.32,18.9,2.81l-.52,6.71h0Zm26.72-.43l-.73-6.68c6.33-.69,12.66-1.84,18.8-3.42l1.67,6.52c-6.45,1.65-13.09,2.86-19.74,3.59h0Zm-72-10.79c-6.13-2.65-12.12-5.77-17.81-9.26l3.52-5.73c5.42,3.33,11.13,6.3,16.96,8.82l-2.67,6.17h0Zm116.89-1.86l-2.87-6.08c5.74-2.71,11.35-5.85,16.66-9.35l3.7,5.62c-5.57,3.67-11.46,6.97-17.49,9.81Zm-156.08-23.46c-4.94-4.49-9.6-9.37-13.85-14.51l5.18-4.29c4.05,4.89,8.49,9.54,13.2,13.83l-4.53,4.97Zm194.41-3.08l-4.68-4.83c4.57-4.43,8.86-9.22,12.76-14.24l5.31,4.13c-4.09,5.27-8.6,10.3-13.39,14.94Zm-223.32-33.52c-3.22-5.83-6.05-11.95-8.41-18.2l6.29-2.39c2.26,5.95,4.95,11.78,8.01,17.34l-5.89,3.25Zm251.05-3.98l-5.99-3.06c2.89-5.66,5.4-11.59,7.46-17.6l6.36,2.18c-2.16,6.32-4.8,12.54-7.84,18.49h.01ZM59.48,223.97c-1.14-6.57-1.82-13.28-2.03-19.96l6.72-.21c.2,6.36,.85,12.76,1.94,19.01l-6.63,1.15h0Zm280.57-4.47l-6.66-.94c.89-6.27,1.33-12.68,1.33-19.07,0-.75,0-1.5-.02-2.25l6.72-.11c.01,.79,.02,1.57,.02,2.36,0,6.7-.47,13.43-1.4,20.01h.01ZM65.74,178.38l-6.65-1.04c1.03-6.6,2.55-13.18,4.5-19.55l6.43,1.97c-1.86,6.07-3.3,12.34-4.29,18.62h.01Zm266.17-6.46c-1.28-6.22-3.03-12.4-5.19-18.39l6.32-2.28c2.27,6.28,4.1,12.78,5.45,19.31l-6.59,1.36h.01Zm-252.14-35.69l-5.94-3.15c3.12-5.89,6.69-11.62,10.63-17.03l5.44,3.96c-3.75,5.15-7.15,10.61-10.12,16.22h-.01Zm236.08-5.72c-3.24-5.46-6.91-10.75-10.89-15.7l5.24-4.21c4.18,5.2,8.02,10.75,11.43,16.48l-5.79,3.43h.01Zm-209.11-29.61l-4.61-4.9c4.86-4.57,10.09-8.84,15.54-12.68l3.88,5.5c-5.19,3.66-10.18,7.73-14.81,12.08Zm180.48-4.37c-4.84-4.13-10.01-7.95-15.38-11.36l3.6-5.68c5.63,3.57,11.06,7.59,16.14,11.92l-4.37,5.12h.01Zm-143.57-20.36l-2.78-6.13c6.09-2.76,12.42-5.1,18.82-6.96l1.88,6.46c-6.1,1.77-12.13,4-17.92,6.63Zm105.5-2.56c-5.92-2.34-12.06-4.27-18.24-5.75l1.56-6.54c6.49,1.55,12.93,3.58,19.15,6.03l-2.47,6.25h0Zm-62.57-8.82l-.63-6.7c4.44-.42,8.95-.63,13.42-.63h.05c2.21,0,4.4,.05,6.59,.15l-.3,6.72c-2.1-.09-4.12-.27-6.33-.14-4.26,0-8.56,.2-12.79,.6h-.01Z"
            />
          </g>
          <g className="cls-3">
            <path
              className="cls-16"
              d="M181.44,244.93l-13.04-2.94c-7.41,2.39-14.65,3.71-21.73,3.97-.77,.08-1.56,.13-2.36,.13h-2.36c-6.65-.09-12.64-1.17-17.96-3.27-5.32-2.09-9.84-5.1-13.55-9.04-3.71-3.93-6.56-8.76-8.57-14.49s-3-12.3-3-19.74,1.11-13.59,3.32-19.23c2.21-5.64,5.37-10.42,9.46-14.36,4.09-3.93,8.99-6.97,14.7-9.1s12.06-3.25,19.05-3.33h5.88c3.83,.26,7.78,.72,11.83,1.37s7.86,1.46,11.44,2.41v27.58l-22.23-24.2c-1.7-.51-3.41-.77-5.11-.77-6.73,0-12.1,3.22-16.1,9.66-4.01,6.45-5.96,16.02-5.88,28.74,0,13.23,1.94,23.41,5.82,30.53,3.88,7.13,9.58,10.69,17.09,10.69,1.45,0,2.94-.13,4.48-.38,1.54-.26,3.11-.68,4.73-1.28v-24.45l-10.83-14.08h45.39l-10.5,14.08v31.49h.03Z"
            />
            <path
              className="cls-14"
              d="M250.18,160.7c-1.79-.51-3.54-.77-5.25-.77-7,0-12.42,3.34-16.26,10.03s-5.72,16.38-5.63,29.08c.08,13.72,2.01,23.94,5.76,30.67s9.26,10.1,16.51,10.1c.77,0,1.56-.04,2.37-.13s1.64-.26,2.5-.51l22.27-23.94v28.1c-4.61,.87-9.5,1.57-14.66,2.09-5.17,.52-9.71,.78-13.63,.78-7.08,0-13.55-1-19.39-3.01-5.85-2.01-10.84-4.97-14.98-8.91-4.14-3.93-7.34-8.78-9.6-14.55-2.26-5.77-3.39-12.46-3.39-20.06s1.15-14.02,3.46-19.74c2.3-5.73,5.55-10.53,9.73-14.42,4.18-3.89,9.19-6.86,15.04-8.91,5.84-2.05,12.31-3.08,19.39-3.08,4.27,0,8.92,.33,13.95,.98,5.03,.65,9.73,1.59,14.08,2.81v27.58l-22.27-24.2h0Z"
            />
          </g>
          <g>
            <path
              className="cls-13"
              d="M185.22,243.91l-13.04-2.94c-7.41,2.39-14.65,3.71-21.73,3.97-.77,.08-1.56,.13-2.36,.13h-2.36c-6.65-.09-12.64-1.17-17.96-3.27-5.32-2.09-9.84-5.1-13.55-9.04-3.71-3.93-6.56-8.76-8.57-14.49-2-5.73-3-12.3-3-19.74s1.11-13.59,3.32-19.23c2.21-5.64,5.37-10.42,9.46-14.36,4.09-3.93,8.99-6.97,14.7-9.1,5.71-2.14,12.06-3.25,19.05-3.33h5.88c3.83,.26,7.78,.72,11.83,1.37s7.86,1.46,11.44,2.41v27.58l-22.23-24.2c-1.7-.51-3.41-.77-5.11-.77-6.73,0-12.1,3.22-16.1,9.66-4.01,6.45-5.96,16.02-5.88,28.74,0,13.23,1.94,23.41,5.82,30.53s9.58,10.69,17.09,10.69c1.45,0,2.94-.13,4.48-.38,1.54-.26,3.11-.68,4.73-1.28v-24.45l-10.83-14.08h45.39l-10.5,14.08v31.49h.03Z"
            />
            <path
              className="cls-12"
              d="M253.96,159.68c-1.79-.51-3.54-.77-5.25-.77-7,0-12.42,3.34-16.26,10.03s-5.72,16.38-5.63,29.08c.08,13.72,2.01,23.94,5.76,30.67s9.26,10.1,16.51,10.1c.77,0,1.56-.04,2.37-.13s1.64-.26,2.5-.51l22.27-23.94v28.1c-4.61,.87-9.5,1.57-14.66,2.09-5.17,.52-9.71,.78-13.63,.78-7.08,0-13.55-1-19.39-3.01-5.85-2.01-10.84-4.97-14.98-8.91-4.14-3.93-7.34-8.78-9.6-14.55-2.26-5.77-3.39-12.46-3.39-20.06s1.15-14.02,3.46-19.74c2.3-5.73,5.55-10.53,9.73-14.42,4.18-3.89,9.19-6.86,15.04-8.91,5.84-2.05,12.31-3.08,19.39-3.08,4.27,0,8.92,.33,13.95,.98,5.03,.65,9.73,1.59,14.08,2.81v27.58l-22.27-24.2h0Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 398.72 398.72">
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <defs>
        <style>
          {
            "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #00ff62;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #00994c;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\n        fill-rule: evenodd;\n      }\n\n      .cls-7 {\n        fill: #00b55e;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-5);\n      }\n    "
          }
        </style>
        <linearGradient
          id="linear-gradient"
          x1={58.39}
          y1={801.61}
          x2={340.33}
          y2={519.67}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#61ff4f" />
          <stop offset={0.08} stopColor="#42e753" />
          <stop offset={0.16} stopColor="#25d158" />
          <stop offset={0.25} stopColor="#10c15b" />
          <stop offset={0.33} stopColor="#04b85d" />
          <stop offset={0.41} stopColor="#00b55e" />
          <stop offset={1} stopColor="#00ff62" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1={197.43}
          y1={653.65}
          x2={197.91}
          y2={654.69}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#5fa100" />
          <stop offset={1} stopColor="#7ba100" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1={114.06}
          y1={739.07}
          x2={277.79}
          y2={575.33}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#61ff4f" />
          <stop offset={0.1} stopColor="#4aee52" />
          <stop offset={0.27} stopColor="#2ad557" />
          <stop offset={0.44} stopColor="#12c35b" />
          <stop offset={0.59} stopColor="#04b85d" />
          <stop offset={0.72} stopColor="#00b55e" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1={197.68}
          y1={653.86}
          x2={197.68}
          y2={654.8}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-5"
          x1={197.68}
          y1={653.86}
          x2={197.68}
          y2={654.8}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1={197.68}
          y1={653.86}
          x2={197.68}
          y2={654.8}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1={197.68}
          y1={653.86}
          x2={197.68}
          y2={654.8}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fffdc7" />
          <stop offset={0.2} stopColor="#fffdda" />
          <stop offset={0.47} stopColor="#fffeee" />
          <stop offset={0.73} stopColor="#fffefa" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-8"
          x1={2.51}
          y1={728.6}
          x2={354.8}
          y2={728.6}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" stopOpacity={0} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.06} />
          <stop offset={0.03} stopColor="#fff" stopOpacity={0.26} />
          <stop offset={0.05} stopColor="#fff" stopOpacity={0.44} />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.59} />
          <stop offset={0.1} stopColor="#fff" stopOpacity={0.72} />
          <stop offset={0.13} stopColor="#fff" stopOpacity={0.82} />
          <stop offset={0.16} stopColor="#fff" stopOpacity={0.9} />
          <stop offset={0.2} stopColor="#fff" stopOpacity={0.96} />
          <stop offset={0.24} stopColor="#fff" stopOpacity={0.99} />
          <stop offset={0.31} stopColor="#fff" />
          <stop offset={0.38} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.61} stopColor="#fff" stopOpacity={0.56} />
          <stop offset={0.79} stopColor="#fff" stopOpacity={0.31} />
          <stop offset={0.93} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={1} stopColor="#fff" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="linear-gradient-9"
          x1={116.31}
          y1={684.46}
          x2={196.05}
          y2={638.41}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fafff8" />
          <stop offset={0.1} stopColor="#d9ffcb" />
          <stop offset={0.19} stopColor="#bdffa5" />
          <stop offset={0.28} stopColor="#a6ff85" />
          <stop offset={0.38} stopColor="#95ff6d" />
          <stop offset={0.48} stopColor="#88ff5c" />
          <stop offset={0.59} stopColor="#81ff52" />
          <stop offset={0.72} stopColor="#7fff4f" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-10"
          x1={208.23}
          y1={687.94}
          x2={291.74}
          y2={639.72}
          gradientTransform="translate(0 860) scale(1 -1)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fafff8" />
          <stop offset={0.1} stopColor="#d9ffcb" />
          <stop offset={0.19} stopColor="#bdffa5" />
          <stop offset={0.28} stopColor="#a6ff85" />
          <stop offset={0.38} stopColor="#95ff6d" />
          <stop offset={0.48} stopColor="#88ff5c" />
          <stop offset={0.59} stopColor="#81ff52" />
          <stop offset={0.72} stopColor="#7fff4f" />
        </linearGradient>
      </defs>
      <g id="_\u0428\u0430\u0440_1" data-name=" \u0428\u0430\u0440 1">
        <g>
          <g>
            <circle className="cls-1" cx={199.36} cy={199.36} r={199.36} />
            <polygon
              className="cls-9"
              points="198.22 206.15 197.89 206.04 197.97 206.3 197.75 206.11 197.68 206.44 197.6 206.15 197.38 206.33 197.46 206.08 197.16 206.15 197.38 205.89 197.13 205.82 197.38 205.75 197.13 205.49 197.46 205.6 197.38 205.35 197.6 205.53 197.68 205.2 197.75 205.53 197.97 205.35 197.89 205.6 198.22 205.49 197.97 205.75 198.26 205.82 197.97 205.89 198.22 206.15"
            />
            <circle className="cls-2" cx={199.36} cy={199.36} r={115.78} />
            <circle className="cls-6" cx={195.92} cy={202.79} r={115.78} />
            <path
              className="cls-4"
              d="M200.4,82.67c-27.41,0-52.57,9.54-72.4,25.46,18.44-12.41,40.65-19.66,64.56-19.66,63.94,0,115.78,51.83,115.78,115.78,0,36.53-16.94,69.09-43.37,90.31,30.89-20.79,51.22-56.08,51.22-96.12,0-63.94-51.83-115.78-115.78-115.78h-.01Z"
            />
            <path
              className="cls-7"
              d="M199.4,57.36c-78.42,0-142,63.58-142,142s63.58,142,142,142,142-63.58,142-142S277.82,57.36,199.4,57.36Zm0,271.16c-71.33,0-129.16-57.82-129.16-129.15S128.07,70.2,199.4,70.2s129.15,57.82,129.15,129.16-57.82,129.15-129.15,129.15h0Z"
            />
            <polygon
              className="cls-10"
              points="197.95 205.91 198.21 206.14 197.89 206.04 197.79 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.37 205.91 197.11 205.81 197.37 205.75 197.11 205.49 197.47 205.59 197.37 205.36 197.6 205.52 197.66 205.2 197.76 205.52 197.95 205.36 197.89 205.59 198.21 205.49 197.95 205.75 198.25 205.81 197.95 205.91"
            />
            <polygon
              className="cls-13"
              points="197.95 205.91 198.21 206.14 197.89 206.04 197.79 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.37 205.91 197.11 205.81 197.37 205.75 197.11 205.49 197.47 205.59 197.37 205.36 197.6 205.52 197.66 205.2 197.76 205.52 197.95 205.36 197.89 205.59 198.21 205.49 197.95 205.75 198.25 205.81 197.95 205.91"
            />
            <polygon
              className="cls-11"
              points="197.95 205.91 198.21 206.14 197.89 206.04 197.79 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.37 205.91 197.11 205.81 197.37 205.75 197.11 205.49 197.47 205.59 197.37 205.36 197.6 205.52 197.66 205.2 197.76 205.52 197.95 205.36 197.89 205.59 198.21 205.49 197.95 205.75 198.25 205.81 197.95 205.91"
            />
            <polygon
              className="cls-12"
              points="197.95 205.91 198.21 206.14 197.89 206.04 197.79 206.04 197.73 206.01 197.63 206.01 197.57 206.04 197.47 206.07 197.18 206.14 197.37 205.91 197.11 205.81 197.37 205.75 197.11 205.49 197.47 205.59 197.37 205.36 197.6 205.52 197.66 205.2 197.76 205.52 197.95 205.36 197.89 205.59 198.21 205.49 197.95 205.75 198.25 205.81 197.95 205.91"
            />
            <path
              className="cls-8"
              d="M7.6,214.59C7.6,104.35,96.97,14.98,207.21,14.98c58.48,0,111.08,25.15,147.59,65.22C319.1,32.64,262.24,1.86,198.2,1.86,90.12,1.86,2.51,89.47,2.51,197.55c0,22.19,3.75,43.5,10.56,63.39-3.54-14.88-5.47-30.38-5.47-46.34h0Z"
            />
            <path
              className="cls-3"
              d="M188.32,341.08c-6.67-.52-13.34-1.51-19.84-2.95l1.46-6.56c6.19,1.38,12.55,2.32,18.9,2.81l-.52,6.71h0Zm26.72-.43l-.73-6.68c6.33-.69,12.66-1.84,18.8-3.42l1.67,6.52c-6.45,1.65-13.09,2.86-19.74,3.59h0Zm-72-10.79c-6.13-2.65-12.12-5.77-17.81-9.26l3.52-5.73c5.42,3.33,11.13,6.3,16.96,8.82l-2.67,6.17h0Zm116.89-1.86l-2.87-6.08c5.74-2.71,11.35-5.85,16.66-9.35l3.7,5.62c-5.57,3.67-11.46,6.97-17.49,9.81h0Zm-156.08-23.46c-4.94-4.49-9.6-9.37-13.85-14.51l5.18-4.29c4.05,4.89,8.49,9.54,13.2,13.83l-4.53,4.97h0Zm194.41-3.08l-4.68-4.83c4.57-4.43,8.86-9.22,12.76-14.24l5.31,4.13c-4.09,5.27-8.6,10.3-13.39,14.94h0Zm-223.32-33.52c-3.22-5.83-6.05-11.95-8.41-18.2l6.29-2.39c2.26,5.95,4.95,11.78,8.01,17.34l-5.89,3.25Zm251.05-3.98l-5.99-3.06c2.89-5.66,5.4-11.59,7.46-17.6l6.36,2.18c-2.16,6.32-4.8,12.54-7.84,18.49h.01ZM59.49,223.96c-1.14-6.57-1.82-13.28-2.03-19.96l6.72-.21c.2,6.36,.85,12.76,1.94,19.01l-6.63,1.15h0Zm280.57-4.47l-6.66-.94c.89-6.27,1.33-12.68,1.33-19.07,0-.75,0-1.5-.02-2.25l6.72-.11c.01,.79,.02,1.57,.02,2.36,0,6.7-.47,13.43-1.4,20.01h.01ZM65.75,178.37l-6.65-1.04c1.03-6.6,2.55-13.18,4.5-19.55l6.43,1.97c-1.86,6.07-3.3,12.34-4.29,18.62h.01Zm266.17-6.46c-1.28-6.22-3.03-12.4-5.19-18.39l6.32-2.28c2.27,6.28,4.1,12.78,5.45,19.31l-6.59,1.36h0Zm-252.14-35.69l-5.94-3.15c3.12-5.89,6.69-11.62,10.63-17.03l5.44,3.96c-3.75,5.15-7.15,10.61-10.12,16.22h0Zm236.08-5.72c-3.24-5.46-6.91-10.75-10.89-15.7l5.24-4.21c4.18,5.2,8.02,10.75,11.43,16.48l-5.79,3.43h.01Zm-209.11-29.61l-4.61-4.9c4.86-4.57,10.09-8.84,15.54-12.68l3.88,5.5c-5.19,3.66-10.18,7.73-14.81,12.08Zm180.48-4.37c-4.84-4.13-10.01-7.95-15.38-11.36l3.6-5.68c5.63,3.57,11.06,7.59,16.14,11.92l-4.37,5.12h0Zm-143.57-20.36l-2.78-6.13c6.09-2.76,12.42-5.1,18.82-6.96l1.88,6.46c-6.1,1.77-12.13,4-17.92,6.63h0Zm105.5-2.56c-5.92-2.34-12.06-4.27-18.24-5.75l1.56-6.54c6.49,1.55,12.93,3.58,19.15,6.03l-2.47,6.25h0Zm-62.57-8.82l-.63-6.7c4.44-.42,8.95-.63,13.42-.63h.05c2.21,0,4.4,.05,6.59,.15l-.3,6.72c-2.1-.09-4.12-.27-6.33-.14-4.26,0-8.56,.2-12.79,.6h0Z"
            />
          </g>
          <g>
            <path
              className="cls-3"
              d="M188.2,218.47c0,5.48-1.46,10.06-4.37,13.76-2.91,3.69-6.59,6.63-11.02,8.8-4.43,2.17-9.26,3.69-14.47,4.57-5.21,.87-10.17,1.3-14.87,1.3-2,0-4.32-.13-6.97-.39s-5.41-.63-8.28-1.11-5.78-1.11-8.74-1.89-5.65-1.7-8.09-2.74v-26.6l25.43,25.43c1.57,.17,3.48,.26,5.74,.26s4.39-.17,6.39-.52c1.83-.26,3.61-.67,5.35-1.24,1.74-.56,3.26-1.35,4.56-2.35s2.37-2.19,3.19-3.59c.82-1.39,1.24-3,1.24-4.82,0-2.95-.87-5.46-2.61-7.5s-3.85-3.83-6.33-5.35-5.09-2.82-7.82-3.91-5.15-2.2-7.24-3.33c-3.39-1.57-6.69-3.21-9.91-4.95s-6.11-3.72-8.67-5.94-4.61-4.78-6.13-7.69-2.28-6.33-2.28-10.23c0-4.18,.98-7.89,2.93-11.15s4.74-5.98,8.34-8.15c3.61-2.17,7.98-3.82,13.11-4.95,5.13-1.13,10.91-1.69,17.34-1.69,5.48,0,10.8,.37,15.97,1.11s9.32,1.72,12.45,2.93v28.69h-.26l-23.34-25.95c-.35-.08-.68-.15-.98-.19-.31-.04-.68-.11-1.11-.19h-1.83c-.61,0-1.26,.04-1.96,.13-1.91,.17-3.85,.48-5.8,.91-1.95,.44-3.72,1.13-5.28,2.09-1.57,.96-2.85,2.15-3.85,3.59s-1.5,3.19-1.5,5.28c0,3.65,1.5,6.61,4.5,8.87s6.72,4.3,11.15,6.13c3.48,1.48,7.3,3.07,11.48,4.76,4.17,1.7,8.08,3.78,11.73,6.26s6.69,5.43,9.13,8.86c2.43,3.44,3.65,7.68,3.65,12.71l.03-.02Z"
            />
            <path
              className="cls-3"
              d="M249.62,159.66c-1.83-.52-3.61-.78-5.35-.78-7.13,0-12.65,3.4-16.56,10.22s-5.82,16.69-5.74,29.62c.09,13.97,2.04,24.39,5.87,31.24,3.82,6.86,9.43,10.28,16.82,10.28,.78,0,1.59-.04,2.41-.13,.82-.08,1.67-.26,2.54-.52l22.69-24.38v28.63c-4.69,.89-9.67,1.6-14.93,2.13-5.26,.53-9.89,.8-13.89,.8-7.22,0-13.8-1.02-19.76-3.07-5.96-2.05-11.04-5.07-15.25-9.07-4.22-4-7.48-8.94-9.78-14.82s-3.46-12.69-3.46-20.44,1.17-14.28,3.52-20.11,5.65-10.73,9.91-14.69c4.26-3.96,9.37-6.98,15.32-9.08,5.95-2.09,12.54-3.13,19.75-3.13,4.35,0,9.08,.33,14.21,1,5.13,.67,9.91,1.62,14.34,2.86v28.09l-22.69-24.64h.03Z"
            />
          </g>
          <g>
            <path
              className="cls-5"
              d="M194.94,216.92c0,5.48-1.46,10.06-4.37,13.76-2.91,3.69-6.59,6.63-11.02,8.8-4.43,2.17-9.26,3.69-14.47,4.57-5.21,.87-10.17,1.3-14.87,1.3-2,0-4.32-.13-6.97-.39s-5.41-.63-8.28-1.11-5.78-1.11-8.74-1.89-5.65-1.7-8.09-2.74v-26.6l25.43,25.43c1.57,.17,3.48,.26,5.74,.26s4.39-.17,6.39-.52c1.83-.26,3.61-.67,5.35-1.24,1.74-.56,3.26-1.35,4.56-2.35s2.37-2.19,3.19-3.59c.82-1.39,1.24-3,1.24-4.82,0-2.95-.87-5.46-2.61-7.5s-3.85-3.83-6.33-5.35-5.09-2.82-7.82-3.91-5.15-2.2-7.24-3.33c-3.39-1.57-6.69-3.21-9.91-4.95s-6.11-3.72-8.67-5.94-4.61-4.78-6.13-7.69-2.28-6.33-2.28-10.23c0-4.18,.98-7.89,2.93-11.15s4.74-5.98,8.34-8.15c3.61-2.17,7.98-3.82,13.11-4.95,5.13-1.13,10.91-1.69,17.34-1.69,5.48,0,10.8,.37,15.97,1.11s9.32,1.72,12.45,2.93v28.69h-.26l-23.34-25.95c-.35-.08-.68-.15-.98-.19-.31-.04-.68-.11-1.11-.19h-1.83c-.61,0-1.26,.04-1.96,.13-1.91,.17-3.85,.48-5.8,.91-1.95,.44-3.72,1.13-5.28,2.09-1.57,.96-2.85,2.15-3.85,3.59s-1.5,3.19-1.5,5.28c0,3.65,1.5,6.61,4.5,8.87s6.72,4.3,11.15,6.13c3.48,1.48,7.3,3.07,11.48,4.76,4.17,1.7,8.08,3.78,11.73,6.26s6.69,5.43,9.13,8.86c2.43,3.44,3.65,7.68,3.65,12.71l.03-.02Z"
            />
            <path
              className="cls-14"
              d="M256.35,158.12c-1.83-.52-3.61-.78-5.35-.78-7.13,0-12.65,3.4-16.56,10.22s-5.82,16.69-5.74,29.62c.09,13.97,2.04,24.39,5.87,31.24,3.82,6.86,9.43,10.28,16.82,10.28,.78,0,1.59-.04,2.41-.13,.82-.08,1.67-.26,2.54-.52l22.69-24.38v28.63c-4.69,.89-9.67,1.6-14.93,2.13-5.26,.53-9.89,.8-13.89,.8-7.22,0-13.8-1.02-19.76-3.07-5.96-2.05-11.04-5.07-15.25-9.07-4.22-4-7.48-8.94-9.78-14.82s-3.46-12.69-3.46-20.44,1.17-14.28,3.52-20.11,5.65-10.73,9.91-14.69c4.26-3.96,9.37-6.98,15.32-9.08,5.95-2.09,12.54-3.13,19.75-3.13,4.35,0,9.08,.33,14.21,1s9.91,1.62,14.34,2.86v28.09l-22.69-24.64h.03Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Crypto = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <path
        fill="#6680E3"
        d="M15.957 8A7.958 7.958 0 1 1 .04 8a7.958 7.958 0 0 1 15.916 0Z"
      />
      <path
        fill="#ECF0F1"
        d="m7.974 2.995-.066.225v6.514l.066.066 3.024-1.788-3.024-5.017Z"
      />
      <path
        fill="#ECF0F1"
        d="M7.975 2.995 4.951 8.012 7.975 9.8V2.995Zm0 7.789-.037.045v2.32l.037.11L11 8.996l-3.025 1.787Z"
      />
      <path
        fill="#ECF0F1"
        d="M7.975 13.258v-2.474L4.951 8.997l3.024 4.261ZM7.973 9.8l3.023-1.787-3.023-1.375V9.8Z"
      />
      <path fill="#ECF0F1" d="M4.951 8.013 7.975 9.8V6.638L4.95 8.013Z" />
    </svg>
  );
};

export const Placeholder = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 451.9 82.7"
    //   style={{
        enableBackground= "new 0 0 451.9 82.7"
    //   }}
      xmlSpace="preserve">
      <script id="eppiocemhmnlbhjplcgkofciiegomcon" />
      <script />
      <script />
      <style type="text/css">
        {
          "\n\t.st0{fill:#162C39;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#8690A4;}\n"
        }
      </style>
      <title>{"Untitled-1"}</title>
      <path
        className="st0"
        d="M44.9,50.4V17.1H6.8c-1.7,0-3.1,1.4-3.1,3.1c0,0.4,0.1,0.9,0.3,1.3l8.1,17.7c0.4,1,0.4,2.1-0.2,3L0.5,59.5  C-0.4,61,0,62.9,1.4,63.8c0.5,0.3,1.1,0.5,1.7,0.5h63.6c1.7,0,3.1-1.4,3.1-3.1v-5.6H50.1C47.2,55.6,44.9,53.3,44.9,50.4z"
      />
      <path
        className="st0"
        d="M451.4,59.5L440,42.1c-0.6-0.9-0.7-2-0.2-3l8.1-17.7c0.7-1.6,0-3.4-1.5-4.1c-0.4-0.2-0.8-0.3-1.3-0.3H407v33.3  c0,2.9-2.3,5.2-5.2,5.2c0,0,0,0,0,0h-19.6v5.6c0,1.7,1.4,3.1,3.1,3.1h63.6c1.7,0,3.1-1.4,3.1-3.1C451.9,60.6,451.7,60.1,451.4,59.5z  "
      />
      <path
        className="st0"
        d="M53.1,0h345.6c2.1,0,3.8,1.7,3.8,3.8v43.1c0,2.1-1.7,3.8-3.8,3.8H53.1c-2.1,0-3.8-1.7-3.8-3.8V3.8  C49.3,1.7,51,0,53.1,0z"
      />
      <g className="st1">
        <path
          className="st2"
          d="M118.3,18.1h4.2c1.9,0,3.3,0.3,4.2,0.8c0.9,0.5,1.3,1.4,1.3,2.6c0,0.8-0.2,1.5-0.6,2s-0.9,0.8-1.5,0.9v0.1   c0.9,0.2,1.5,0.5,1.8,1.1c0.4,0.5,0.6,1.2,0.6,2.1c0,1.2-0.4,2.2-1.3,2.9c-0.9,0.7-2.1,1-3.6,1h-5V18.1z M121.2,23.4h1.7   c0.8,0,1.3-0.1,1.7-0.4s0.5-0.6,0.5-1.2c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.2-1-0.3-1.8-0.3h-1.5V23.4z M121.2,25.7v3.5h1.9   c0.8,0,1.4-0.2,1.7-0.5c0.4-0.3,0.6-0.8,0.6-1.4c0-1.1-0.8-1.7-2.4-1.7H121.2z"
        />
        <path className="st2" d="M131,31.6V18.1h2.9v11.1h5.5v2.4H131z" />
        <path
          className="st2"
          d="M149.9,31.6l-1-3.2H144l-1,3.2h-3.1l4.7-13.5h3.5l4.8,13.5H149.9z M148.2,26c-0.9-2.9-1.4-4.5-1.5-4.9   c-0.1-0.4-0.2-0.7-0.2-0.9c-0.2,0.8-0.8,2.7-1.7,5.8H148.2z"
        />
        <path
          className="st2"
          d="M160.4,20.3c-1.1,0-1.9,0.4-2.5,1.2s-0.9,1.9-0.9,3.4c0,3,1.1,4.5,3.4,4.5c0.9,0,2.1-0.2,3.4-0.7v2.4   c-1.1,0.5-2.3,0.7-3.7,0.7c-2,0-3.5-0.6-4.5-1.8c-1-1.2-1.6-2.9-1.6-5.1c0-1.4,0.3-2.6,0.8-3.7c0.5-1.1,1.2-1.9,2.2-2.4   s2.1-0.8,3.4-0.8c1.3,0,2.6,0.3,3.9,0.9l-0.9,2.3c-0.5-0.2-1-0.4-1.5-0.6S160.9,20.3,160.4,20.3z"
        />
        <path
          className="st2"
          d="M177.5,31.6h-3.2l-3.5-5.7l-1.2,0.9v4.8h-2.9V18.1h2.9v6.2l1.1-1.6l3.6-4.6h3.2l-4.7,6L177.5,31.6z"
        />
        <path
          className="st2"
          d="M177.8,35.5c-0.6,0-1.2-0.1-1.7-0.2v-2.4c0.5,0.1,0.9,0.2,1.3,0.2c0.6,0,1.1-0.2,1.3-0.6s0.4-1,0.4-1.8V18.1   h2.9v12.6c0,1.6-0.4,2.8-1.1,3.6C180.2,35.1,179.2,35.5,177.8,35.5z"
        />
        <path
          className="st2"
          d="M193.7,31.6l-1-3.2h-4.9l-1,3.2h-3.1l4.7-13.5h3.5l4.8,13.5H193.7z M192,26c-0.9-2.9-1.4-4.5-1.5-4.9   c-0.1-0.4-0.2-0.7-0.2-0.9c-0.2,0.8-0.8,2.7-1.7,5.8H192z"
        />
        <path
          className="st2"
          d="M204.1,20.3c-1.1,0-1.9,0.4-2.5,1.2s-0.9,1.9-0.9,3.4c0,3,1.1,4.5,3.4,4.5c0.9,0,2.1-0.2,3.4-0.7v2.4   c-1.1,0.5-2.3,0.7-3.7,0.7c-2,0-3.5-0.6-4.5-1.8c-1-1.2-1.6-2.9-1.6-5.1c0-1.4,0.3-2.6,0.8-3.7c0.5-1.1,1.2-1.9,2.2-2.4   s2.1-0.8,3.4-0.8c1.3,0,2.6,0.3,3.9,0.9l-0.9,2.3c-0.5-0.2-1-0.4-1.5-0.6S204.6,20.3,204.1,20.3z"
        />
        <path
          className="st2"
          d="M221.3,31.6H218l-3.5-5.7l-1.2,0.9v4.8h-2.9V18.1h2.9v6.2l1.1-1.6l3.6-4.6h3.2l-4.7,6L221.3,31.6z"
        />
        <path
          className="st2"
          d="M237.1,22.3c0,1.4-0.5,2.6-1.4,3.3c-0.9,0.8-2.2,1.2-3.9,1.2h-1.2v4.8h-2.9V18.1h4.3c1.6,0,2.9,0.4,3.7,1.1   C236.7,19.9,237.1,20.9,237.1,22.3z M230.7,24.4h0.9c0.9,0,1.5-0.2,2-0.5c0.4-0.3,0.7-0.9,0.7-1.5c0-0.7-0.2-1.2-0.5-1.5   c-0.4-0.3-0.9-0.5-1.7-0.5h-1.3V24.4z"
        />
        <path
          className="st2"
          d="M247.9,31.6l-1-3.2H242l-1,3.2H238l4.7-13.5h3.5l4.8,13.5H247.9z M246.3,26c-0.9-2.9-1.4-4.5-1.5-4.9   c-0.1-0.4-0.2-0.7-0.2-0.9c-0.2,0.8-0.8,2.7-1.7,5.8H246.3z"
        />
        <path
          className="st2"
          d="M256.9,23.6l2.8-5.5h3.1l-4.5,8.2v5.2h-2.8v-5.1l-4.5-8.3h3.1L256.9,23.6z"
        />
        <path
          className="st2"
          d="M272.4,27.8c0,1.2-0.4,2.2-1.3,2.9c-0.9,0.7-2.1,1-3.6,1c-1.4,0-2.7-0.3-3.8-0.8v-2.7c0.9,0.4,1.7,0.7,2.3,0.9   c0.6,0.2,1.2,0.2,1.7,0.2c0.6,0,1.1-0.1,1.4-0.4c0.3-0.2,0.5-0.6,0.5-1.1c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.4-0.4-0.6-0.6   c-0.3-0.2-0.9-0.5-1.7-0.9c-0.8-0.4-1.4-0.8-1.8-1.1c-0.4-0.4-0.7-0.8-1-1.2c-0.2-0.5-0.4-1-0.4-1.7c0-1.2,0.4-2.1,1.2-2.8   c0.8-0.7,1.9-1,3.3-1c0.7,0,1.4,0.1,2,0.2c0.6,0.2,1.3,0.4,2,0.7l-0.9,2.2c-0.7-0.3-1.3-0.5-1.8-0.6c-0.5-0.1-0.9-0.2-1.4-0.2   c-0.5,0-1,0.1-1.2,0.4s-0.4,0.6-0.4,1c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.6,0.5c0.3,0.2,0.9,0.5,1.8,0.9   c1.3,0.6,2.1,1.2,2.6,1.8C272.2,26.2,272.4,26.9,272.4,27.8z"
        />
        <path
          className="st2"
          d="M287.7,21.1c0,0.8-0.3,1.6-0.8,2.1c-0.5,0.6-1.2,1-2.1,1.2v0.1c1.1,0.1,1.9,0.5,2.5,1c0.6,0.5,0.8,1.2,0.8,2.1   c0,1.3-0.5,2.3-1.4,3s-2.3,1.1-4,1.1c-1.5,0-2.8-0.2-3.9-0.7v-2.4c0.5,0.3,1.1,0.5,1.7,0.6s1.2,0.2,1.9,0.2c0.9,0,1.6-0.2,2.1-0.5   c0.4-0.3,0.7-0.8,0.7-1.5c0-0.6-0.3-1.1-0.8-1.3c-0.5-0.3-1.3-0.4-2.5-0.4h-1v-2.2h1c1,0,1.8-0.1,2.3-0.4c0.5-0.3,0.7-0.7,0.7-1.4   c0-1-0.6-1.5-1.9-1.5c-0.4,0-0.9,0.1-1.3,0.2s-1,0.4-1.5,0.8l-1.3-2c1.2-0.9,2.7-1.3,4.4-1.3c1.4,0,2.5,0.3,3.3,0.8   S287.7,20.1,287.7,21.1z"
        />
        <path
          className="st2"
          d="M300.6,31.6h-2.9V20.5h-3.7v-2.4h10.2v2.4h-3.7V31.6z"
        />
        <path
          className="st2"
          d="M318.5,24.8c0,2.2-0.6,3.9-1.7,5.1c-1.1,1.2-2.7,1.8-4.7,1.8s-3.6-0.6-4.7-1.8c-1.1-1.2-1.7-2.9-1.7-5.2   c0-2.2,0.6-4,1.7-5.1c1.1-1.2,2.7-1.8,4.8-1.8c2.1,0,3.6,0.6,4.7,1.8C318,20.9,318.5,22.6,318.5,24.8z M308.7,24.8   c0,1.5,0.3,2.6,0.9,3.4s1.4,1.1,2.6,1.1c2.3,0,3.4-1.5,3.4-4.5c0-3-1.1-4.5-3.4-4.5c-1.1,0-2,0.4-2.6,1.1   C309,22.2,308.7,23.3,308.7,24.8z"
        />
        <path
          className="st2"
          d="M334.7,31.6h-9.4v-2l3.4-3.4c1-1,1.7-1.7,2-2.1s0.5-0.8,0.7-1.1c0.1-0.3,0.2-0.7,0.2-1c0-0.5-0.1-0.9-0.4-1.2   s-0.7-0.4-1.2-0.4c-0.5,0-1,0.1-1.5,0.4c-0.5,0.2-1,0.6-1.5,1l-1.5-1.8c0.7-0.6,1.2-1,1.6-1.2c0.4-0.2,0.9-0.4,1.4-0.5   s1.1-0.2,1.7-0.2c0.8,0,1.6,0.2,2.2,0.5c0.6,0.3,1.1,0.7,1.5,1.3c0.4,0.6,0.5,1.2,0.5,1.9c0,0.6-0.1,1.2-0.3,1.7s-0.6,1.1-1,1.7   c-0.5,0.6-1.3,1.4-2.4,2.4l-1.7,1.6v0.1h5.9V31.6z"
        />
      </g>
      <g className="st1">
        <path className="st2" d="M115.9,77.2V63.7h2.9v13.5H115.9z" />
        <path
          className="st2"
          d="M134,77.2h-3.6L124.6,67h-0.1c0.1,1.8,0.2,3.1,0.2,3.8v6.3h-2.5V63.7h3.6l5.8,10.1h0.1c-0.1-1.7-0.1-3-0.1-3.7   v-6.4h2.6V77.2z"
        />
        <path
          className="st2"
          d="M145.4,73.4c0,1.2-0.4,2.2-1.3,2.9s-2.1,1-3.6,1c-1.4,0-2.7-0.3-3.8-0.8v-2.7c0.9,0.4,1.7,0.7,2.3,0.9   c0.6,0.2,1.2,0.2,1.7,0.2c0.6,0,1.1-0.1,1.4-0.4s0.5-0.6,0.5-1.1c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.4-0.4-0.6-0.6   c-0.3-0.2-0.9-0.5-1.7-0.9c-0.8-0.4-1.4-0.8-1.9-1.1c-0.4-0.4-0.7-0.8-1-1.2c-0.2-0.5-0.4-1-0.4-1.7c0-1.2,0.4-2.1,1.2-2.8   c0.8-0.7,1.9-1,3.3-1c0.7,0,1.4,0.1,2,0.2c0.6,0.2,1.3,0.4,2,0.7l-0.9,2.2c-0.7-0.3-1.3-0.5-1.8-0.6c-0.5-0.1-0.9-0.2-1.4-0.2   c-0.5,0-1,0.1-1.2,0.4c-0.3,0.3-0.4,0.6-0.4,1c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.6,0.5c0.3,0.2,0.9,0.5,1.8,0.9   c1.3,0.6,2.1,1.2,2.6,1.8C145.1,71.8,145.4,72.5,145.4,73.4z"
        />
        <path
          className="st2"
          d="M158.8,63.7v8.7c0,1-0.2,1.9-0.7,2.6c-0.4,0.7-1.1,1.3-1.9,1.7s-1.8,0.6-3,0.6c-1.7,0-3.1-0.4-4-1.3   c-1-0.9-1.4-2.1-1.4-3.6v-8.7h2.8v8.2c0,1,0.2,1.8,0.6,2.3c0.4,0.5,1.1,0.7,2.1,0.7c0.9,0,1.6-0.2,2-0.7c0.4-0.5,0.6-1.3,0.6-2.3   v-8.2H158.8z"
        />
        <path
          className="st2"
          d="M164.9,72v5.2h-2.9V63.7h3.9c1.8,0,3.2,0.3,4.1,1c0.9,0.7,1.3,1.7,1.3,3c0,0.8-0.2,1.5-0.7,2.1   c-0.4,0.6-1.1,1.1-1.9,1.4c2,3,3.3,5,4,5.9h-3.2l-3.2-5.2H164.9z M164.9,69.7h0.9c0.9,0,1.6-0.1,2-0.5c0.4-0.3,0.6-0.8,0.6-1.4   c0-0.6-0.2-1.1-0.7-1.4c-0.4-0.3-1.1-0.4-2-0.4h-0.9V69.7z"
        />
        <path
          className="st2"
          d="M182.7,77.2l-1-3.2h-4.9l-1,3.2h-3.1l4.7-13.5h3.5l4.8,13.5H182.7z M181.1,71.6c-0.9-2.9-1.4-4.5-1.5-4.9   c-0.1-0.4-0.2-0.7-0.2-0.9c-0.2,0.8-0.8,2.7-1.7,5.8H181.1z"
        />
        <path
          className="st2"
          d="M199.5,77.2h-3.6L190,67h-0.1c0.1,1.8,0.2,3.1,0.2,3.8v6.3h-2.5V63.7h3.6l5.8,10.1h0.1c-0.1-1.7-0.1-3-0.1-3.7   v-6.4h2.6V77.2z"
        />
        <path
          className="st2"
          d="M208.6,65.9c-1.1,0-1.9,0.4-2.5,1.2s-0.9,1.9-0.9,3.4c0,3,1.1,4.5,3.4,4.5c0.9,0,2.1-0.2,3.4-0.7v2.4   c-1.1,0.5-2.3,0.7-3.7,0.7c-2,0-3.5-0.6-4.5-1.8c-1-1.2-1.6-2.9-1.6-5.1c0-1.4,0.3-2.6,0.8-3.7c0.5-1.1,1.2-1.9,2.2-2.4   s2.1-0.8,3.4-0.8c1.3,0,2.6,0.3,3.9,0.9l-0.9,2.3c-0.5-0.2-1-0.4-1.5-0.6S209,65.9,208.6,65.9z"
        />
        <path
          className="st2"
          d="M222.6,77.2h-7.8V63.7h7.8V66h-4.9v3h4.6v2.3h-4.6v3.5h4.9V77.2z"
        />
        <path
          className="st2"
          d="M239.6,67.9c0,1.4-0.5,2.6-1.4,3.3c-0.9,0.8-2.2,1.2-3.9,1.2h-1.2v4.8h-2.9V63.7h4.3c1.6,0,2.9,0.4,3.7,1.1   C239.2,65.5,239.6,66.5,239.6,67.9z M233.2,70h0.9c0.9,0,1.5-0.2,2-0.5c0.4-0.3,0.7-0.9,0.7-1.5c0-0.7-0.2-1.2-0.5-1.5   c-0.4-0.3-0.9-0.5-1.7-0.5h-1.3V70z"
        />
        <path
          className="st2"
          d="M250.4,77.2l-1-3.2h-4.9l-1,3.2h-3.1l4.7-13.5h3.5l4.8,13.5H250.4z M248.7,71.6c-0.9-2.9-1.4-4.5-1.5-4.9   c-0.1-0.4-0.2-0.7-0.2-0.9c-0.2,0.8-0.8,2.7-1.7,5.8H248.7z"
        />
        <path
          className="st2"
          d="M259.3,69.2l2.8-5.5h3.1l-4.5,8.2v5.2h-2.8V72l-4.5-8.3h3.1L259.3,69.2z"
        />
        <path
          className="st2"
          d="M274.9,73.4c0,1.2-0.4,2.2-1.3,2.9c-0.9,0.7-2.1,1-3.6,1c-1.4,0-2.7-0.3-3.8-0.8v-2.7c0.9,0.4,1.7,0.7,2.3,0.9   c0.6,0.2,1.2,0.2,1.7,0.2c0.6,0,1.1-0.1,1.4-0.4c0.3-0.2,0.5-0.6,0.5-1.1c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.4-0.4-0.6-0.6   c-0.3-0.2-0.9-0.5-1.7-0.9c-0.8-0.4-1.4-0.8-1.8-1.1c-0.4-0.4-0.7-0.8-1-1.2c-0.2-0.5-0.4-1-0.4-1.7c0-1.2,0.4-2.1,1.2-2.8   c0.8-0.7,1.9-1,3.3-1c0.7,0,1.4,0.1,2,0.2c0.6,0.2,1.3,0.4,2,0.7l-0.9,2.2c-0.7-0.3-1.3-0.5-1.8-0.6c-0.5-0.1-0.9-0.2-1.4-0.2   c-0.5,0-1,0.1-1.2,0.4s-0.4,0.6-0.4,1c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.6,0.5c0.3,0.2,0.9,0.5,1.8,0.9   c1.3,0.6,2.1,1.2,2.6,1.8C274.6,71.8,274.9,72.5,274.9,73.4z"
        />
        <path
          className="st2"
          d="M290.7,77.2h-9.4v-2l3.4-3.4c1-1,1.7-1.7,2-2.1s0.5-0.8,0.7-1.1c0.1-0.3,0.2-0.7,0.2-1c0-0.5-0.1-0.9-0.4-1.2   s-0.7-0.4-1.2-0.4c-0.5,0-1,0.1-1.5,0.4c-0.5,0.2-1,0.6-1.5,1l-1.5-1.8c0.7-0.6,1.2-1,1.6-1.2c0.4-0.2,0.9-0.4,1.4-0.5   s1.1-0.2,1.7-0.2c0.8,0,1.6,0.2,2.2,0.5c0.6,0.3,1.1,0.7,1.5,1.3c0.4,0.6,0.5,1.2,0.5,1.9c0,0.6-0.1,1.2-0.3,1.7s-0.6,1.1-1,1.7   c-0.5,0.6-1.3,1.4-2.4,2.4l-1.7,1.6v0.1h5.9V77.2z"
        />
        <path
          className="st2"
          d="M303,77.2h-2.9V66.1h-3.7v-2.4h10.2v2.4H303V77.2z"
        />
        <path
          className="st2"
          d="M321,70.4c0,2.2-0.6,3.9-1.7,5.1c-1.1,1.2-2.7,1.8-4.7,1.8s-3.6-0.6-4.7-1.8c-1.1-1.2-1.7-2.9-1.7-5.2   c0-2.2,0.6-4,1.7-5.1c1.1-1.2,2.7-1.8,4.8-1.8c2.1,0,3.6,0.6,4.7,1.8C320.4,66.5,321,68.2,321,70.4z M311.2,70.4   c0,1.5,0.3,2.6,0.9,3.4s1.4,1.1,2.6,1.1c2.3,0,3.4-1.5,3.4-4.5c0-3-1.1-4.5-3.4-4.5c-1.1,0-2,0.4-2.6,1.1   C311.4,67.8,311.2,68.9,311.2,70.4z"
        />
        <path
          className="st2"
          d="M334.8,77.2h-2.8v-7.8l0-1.3l0-1.4c-0.5,0.5-0.8,0.8-1,0.9l-1.5,1.2l-1.4-1.7l4.3-3.5h2.3V77.2z"
        />
      </g>
    </svg>
  );
};
